import mixpanel from 'mixpanel-browser';
import { USER_MEDIUM_PARAMS } from '../../../constants/images/sizesAndQuality'  
import { CLOUDINARY_API_KEY, CLOUDINARY_NAME  } from '../../../constants/images/cloudinary'  


import cloudinary from 'cloudinary-core'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  //upload_preset : CLOUDINARY_VEHICLE_PRESET,
  api_key : CLOUDINARY_API_KEY,

})

export const trackReferralsViewInviteScreen = (params) => {

    params['owner_avatar_large'] = cl.url(                   
        params.avatar, 
           USER_MEDIUM_PARAMS
        )
    
    mixpanel.track("Referrals - Send Invite Screen")
}

export const trackReferralsEnterEmails = () => {
    mixpanel.track("Referrals - Entered Emails")
}

export const trackReferralsInviteSendAttempt = (error) => {
    mixpanel.track("Referrals - Invites Send Attempt", error)
}

export const trackReferralsInviteSendSuccess = (emailsCount) => {
    mixpanel.track("Referrals - Invites Sent", {
        'referrals_emails_sent_count' : emailsCount
    })
}

export const trackReferralsCopiedReferralLink = () => {
    mixpanel.track("Referrals - Copied Referral Link")
}

export const trackReferralsClickedFacebook = () => {
    mixpanel.track("Referrals - Clicked Facebook")
}

export const trackReferralsClickedTwitter = () => {
    mixpanel.track("Referrals - Clicked Twitter")
}


//manual view can't actually happen...so need no need to include it, but whatever.
export const trackReferralsAcceptInviteView = (desc, code, type, response) => {
    //implicit that you aren't logged in.
    
    mixpanel.track("Referrals - Invite Viewed", {
        'parent_description' : desc,
        'referral_code' : code,
        'entry_method' : type,
        'acceptor_profile_image' : response.acceptor_avatar_cloudinary_url,
        'acceptor_first_name' : response.acceptor_first_name,
        'acceptor_pretty_id' : response.acceptor_pretty_id
    })
}

export const trackReferralManulInputPage = () => {
    mixpanel.track("Referrals - Manual Page Viewed")
}


export const trackReferralsAcceptAttempted = (desc, type, code) => {
    mixpanel.track("Referrals - Code Apply Attempted", {
        'parent_description' : desc,
        'referral_code' : code,
        'entry_method' : type
    })
}

export const trackReferralsAcceptSuccess = (desc, code, type, response) => {
    mixpanel.track("Referrals - Code Applied", {
        'parent_description' : desc,
        'referral_code' : code,
        'entry_method' : type,
        'acceptor_profile_image' : response.acceptor_avatar_cloudinary_url,
        'acceptor_first_name' : response.acceptor_first_name,
        'acceptor_pretty_id' : response.acceptor_pretty_id,
        'sender_profile_image' : response.sender_avatar_cloudinary_url,
        'sender_first_name' : response.sender_first_name,
        'sender_pretty_id' : response.sender_pretty_id,
    })
}


